import { Skeleton } from "@mui/material";
import React from "react";
import { neutral } from "../../../../constants/colorConstants";

const CardSkeleton = ({ type, count }: any) => {
  return (
    <div className="flex flex-row justify-start items-start gap-6 overflow-x-auto">
      {Array.from({ length: count }).map((_, index) => (
        <div>
          {type === "text" ? (
            <div className="w-72 h-55 p-5 mt-5 bg-white rounded-lg flex-col justify-start items-start gap-4 inline-flex ">
              <Skeleton
                width="80%"
                height={15}
                sx={{ bgcolor: neutral[200] }}
              />
              <Skeleton
                width="60%"
                height={15}
                sx={{ bgcolor: neutral[200] }}
              />
              <div className="mt-14">
                <Skeleton
                  width="9rem"
                  height={15}
                  sx={{ bgcolor: neutral[200] }}
                />
              </div>
            </div>
          ) : (
            <div className="h-32 w-36 p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
              <Skeleton variant="circular" sx={{ bgcolor: neutral[200] }} />
              <Skeleton
                variant="text"
                width="70%"
                height={15}
                sx={{ bgcolor: neutral[200] }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CardSkeleton;
